module.exports = __webpack_public_path__ + "img/서브_시야.b36dce38.svg";